import Action from './modules/Action';
import mask from './modules/mask';
import SlickSlider from './modules/SlickSlider';
import FromValidation from './modules/FromValidation';
import Filter from '../app/components/catalog/catalog.filter';
import CatalogAccordion from '../app/components/catalog/CatalogAccordion';


$(() => new SlickSlider().render());
$(() => new FromValidation().render());
$(() => new Filter().render());
$(() => new CatalogAccordion().render());


// jQuery
(function ($) {
  $(function () {


    let $body = $('body');
    let $window = $(window);


    // Клик
    $body.on('click', '[data-click]', function (event) {
      event.preventDefault();

      let data = $(this).data('click');

      new Action(data, this);
    });


    scrollHeader(window);
    $window.on('scroll', function () {
      scrollHeader(this);
    });


    mask();

  });
})(jQuery);


let currentCoordinate = 0;
let currentPosition = 0;

function scrollHeader (window) {
  let $window = $(window);
  let coordinate = $window.scrollTop();
  let $header = $('header');
  let headerHeight = $header.height();


  let sum = coordinate - currentCoordinate + currentPosition;
  if (currentCoordinate < coordinate) { // прокрутили вниз
    if (sum > headerHeight) sum = headerHeight;
  }else { // прокрутили вверх
    if (sum <= 0) sum = 0;
  }
  $header.css({top: -sum + 'px'});
  currentPosition = sum;
  currentCoordinate = coordinate;
}
